import { render, staticRenderFns } from "./AuthFooterPrivacy.vue?vue&type=template&id=c5984c72&"
import script from "./AuthFooterPrivacy.vue?vue&type=script&lang=js&"
export * from "./AuthFooterPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./AuthFooterPrivacy.vue?vue&type=style&index=0&id=c5984c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports